import { render, staticRenderFns } from "./MenuFilters.vue?vue&type=template&id=51a46338&scoped=true"
import script from "./MenuFilters.vue?vue&type=script&lang=js"
export * from "./MenuFilters.vue?vue&type=script&lang=js"
import style0 from "./MenuFilters.vue?vue&type=style&index=0&id=51a46338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a46338",
  null
  
)

export default component.exports